export const createCache = <K, V>(size: number = 0, areKeysEqual: (a: K, b: K) => boolean = Object.is) => {
  const state = new window.Map<K, V>()
  const keysQueue = Array<K>()

  return function withCache(key: K, fallbackFn: (arg: K) => V): V {
    if (state.has(key)) {
      return state.get(key)
    }

    const value = fallbackFn(key)
    state.set(key, value)

    if (!keysQueue.some(areKeysEqual.bind(null, key))) {
      keysQueue.push(key)
      if (size && keysQueue.length > size) {
        const keyToRemove = keysQueue.shift()
        state.delete(keyToRemove)
      }
    }

    return value
  }
}

export const createCacheWithParameter = <T, K, V>(size: number = 0, areKeysEqual?: (a: K, b: K) => boolean) => {
  const superState = new Map<T, ReturnType<typeof createCache<K, V>>>()
  return (parameter: T, key: K, fallbackFn: (arg: K) => V) => {
    let cache = superState.get(parameter)
    if (!cache) {
      cache = createCache<K, V>(size, areKeysEqual)
      superState.set(parameter, cache)
    }
    return cache(key, fallbackFn)
  }
}
